import { createSelector } from 'react-sweet-state';

import type { FieldId } from '../../../../common/types/form/form-fields';
import type { FormRendererState } from '../../types';

export interface FieldRequiredSelectorProps {
	fieldId: FieldId;
}

export const fieldRequiredSelector: import('react-sweet-state').OutputSelector<
	FormRendererState,
	FieldRequiredSelectorProps,
	boolean
> = createSelector(
	(state: FormRendererState) => state.formFields,
	(_, props: FieldRequiredSelectorProps) => props.fieldId,
	(formFields, fieldId) => formFields[fieldId]?.validation?.required ?? false,
);
